export const newsTab = [
	{ label: "공지사항", value: "notice", boardId: '22' },
	// { label: "보도자료", value: "press", boardId: '25' },
	// { label: "언론 속 재단", value: "media",  boardId: '25' },
	{ label: "뉴스레터 웹진", value: "newsletter",  boardId: '24' },
];

export const newsTabEn = [
	{ label: "Notice", value: "notice", boardId: '36' },
	{ label: "Archive", value: "archive",  boardId: '37' },
];

export const channelList = [
	{ label: "숲과나눔 블로그", value: "blog", url: "https://blog.naver.com/korea_she", bg: '#5FC367', text: '숲과나눔이 전하는 따뜻한 이야기'},
	{ label: "숲과나눔 페이스북", value: "facebook", url: "https://www.facebook.com/koreashe", bg: '#3B77EA', text: '다채로운 콘텐츠로 만나는 숲과나눔'},
	{ label: "숲과나눔 유튜브", value: "youtube", url: "https://www.youtube.com/channel/UCrbYikiqpJAXv8xmYhzV-yw", bg: '#E73323', text: '다양한 영상으로 만나는 숲과나눔' },
	{ label: "숲과나눔 인스타그램", value: "instagram", url: "http://www.instagram.com/korea.she", bg: '#005117', text: '제일 먼저 만나는 숲과나눔 소식' },
];

export const channelListEn = [
	{ label: "SHE's Blog", value: "blog", url: "https://blog.naver.com/korea_she", bg: '#5FC367', text: '숲과나눔이 전하는 따뜻한 이야기'},
	{ label: "SHE's Facebook ", value: "facebook", url: "https://www.facebook.com/koreashe", bg: '#3B77EA', text: '다채로운 콘텐츠로 만나는 숲과나눔'},
	{ label: "SHE's Youtube", value: "youtube", url: "https://www.youtube.com/channel/UCrbYikiqpJAXv8xmYhzV-yw", bg: '#E73323', text: '다양한 영상으로 만나는 숲과나눔' },
	{ label: "SHE's Instagram", value: "instagram", url: "http://www.instagram.com/korea.she", bg: '#005117', text: '제일 먼저 만나는 숲과나눔 소식' },
];
